var eligibility = {
    disputeOpened: 'Claim Opened',
    disputeOpenedPending: 'Please allow 60 minutes for dispute claim to appear in the Disputes Center.',
    pleaseVisitDisputeCenter: 'Please visit the <0>Disputes Center</0> for further details.',
    disputeCanceled: 'Dispute Canceled',
    disputeCancelationPending: 'Dispute Cancelation Pending',
    disputeCompleted: 'Dispute Completed',
    disputeUnderReview: 'Dispute Under Review',
    disputeDetails: 'Dispute Details',
    cancelThisDispute: 'Cancel This Dispute',
    disputeThisTransaction: 'Dispute this Transaction',
    howToDispute: 'How can I dispute this transaction?',
    howToDisputeDescription: 'Please contact us via <0>online chat</0> or by calling the number on the back of your card or listed on your statement so one of our representatives can assist you with opening this type of dispute.',
    transactionEligibleError: "We're sorry, but we are currently experiencing issues determining the dispute status for this transaction. Please try again later."
};
export default eligibility;
//# sourceMappingURL=eligibility.js.map